const SEARCH_DATASOURCE = 'index_ds_d71d6026';

const getFunLinkSdk = () => {
  if (typeof window === 'undefined' || !window.FUN_LINK_SDK) {
    throw new Error('Fun Link SDK 未加载');
  }

  return window.FUN_LINK_SDK;
};

const getOmniResponseData = response => {
  if (!response || response.status !== 0) {
    throw response || new Error('OMNI 接口返回异常');
  }

  return response.data;
};

/**
 *  获取omni数据
 * @param {*} position 分发位置
 * @returns
 */
export async function getOmniData(position, dataSources) {
  const response = await getFunLinkSdk().getOmniPositionData({
    format: '',
    param: {
      lang: 'zh-Hans',
      positions: [
        {
          dataSources: dataSources,
          position: position
        }
      ]
    }
  });

  return getOmniResponseData(response)?.[position];
}

export async function getOmniDetail(contentId) {
  const response = await getFunLinkSdk().getOmniDetail({
    format: '',
    param: {
      lang: 'zh-Hans',
      contentId: contentId
    }
  });

  return getOmniResponseData(response)?.[contentId];
}

export const getOmniSearch = async ({ keywords, categoryId = '', page = 1, pageSize = 12 }) => {
  const response = await getFunLinkSdk().getOmniSearchDatasource(SEARCH_DATASOURCE, {
    _omni_text: keywords,
    _omni_withDict: true,
    _omni_aggField: 'categoryId',
    page,
    pageSize,
    ...(categoryId ? { categoryId } : {})
  });

  return getOmniResponseData(response);
};

export const findKeyByTitle = (title, data) => {
  const entry = Object.entries(data).find(([key, value]) => value.title === title);
  return entry ? entry[0] : null;
};

export const Ids = {
  giftRule: {
    channel: 'channel_cat_719a2070',
    dataSources: {
      rule: 'etlrbufc' // 现金红包活动规则
    }
  },
  kv: {
    channel: 'channel_cat_719a2070',
    dataSources: {
      kv: 'ds_cat_902f15b5', // 首屏KV图片
      stage: 'ds_cat_b5d304c1', // 游戏阶段信息
      custom_download: 'ds_cat_9d2c0342', // 自定义下载渠道
      default_download: 'ds_cat_1717631d' // 默认下载渠道
    }
  },
  activity: {
    channel: 'channel_cat_9a2070fd',
    dataSources: {
      ds_id: 'ds_cat_941b75f4' // 公测活动信息MO
      // ds_id: 'ds_cat_bac4c3a5' // 公测活动信息PC
    }
  },
  // 这里使用的预约站的配置
  feature: {
    channel: 'channel_cat_9ae3aec5',
    dataSources: {
      ds_id: 'ds_cat_48c52f22' // 游戏特色信息
    }
  },
  sect: {
    channel: 'channel_cat_70fda197',
    dataSources: {
      ds_id: 'ds_cat_ae2f6979' // 门派介绍信息
    }
  }
};
